function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#11B622"
    },
    d: "M24.1667 4.8335H4.83335C3.50056 4.8335 2.41669 5.91737 2.41669 7.25016V21.7502C2.41669 23.083 3.50056 24.1668 4.83335 24.1668H24.1667C25.4995 24.1668 26.5834 23.083 26.5834 21.7502V7.25016C26.5834 5.91737 25.4995 4.8335 24.1667 4.8335ZM24.1667 7.25016V7.86762L14.5 15.3871L4.83335 7.86883V7.25016H24.1667ZM4.83335 21.7502V10.9283L13.7581 17.8702C13.9697 18.0364 14.231 18.1267 14.5 18.1267C14.7691 18.1267 15.0303 18.0364 15.2419 17.8702L24.1667 10.9283L24.1691 21.7502H4.83335Z",
    fill: "black"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailGreen);
export default __webpack_public_path__ + "static/media/mailGreen.9b9938051b2fef75523ace8a6d62ddf7.svg";
export { ForwardRef as ReactComponent };